module.exports = __webpack_public_path__ + "files/4d2e9ed9598c4e8cae69c468c53e3d26.png";